<template>
    <div class="user-progress">
        <div class="user-progress-content">
            <h3 class="user-progress-title h3">
                <button class="user-progress-button h3" @click="toggleAccordion">
                    {{ $t('home.progress_title') }}
                    <sprite
                        :type="'chevron-down'"
                        :width="12"
                        :height="7"
                    />
                </button>
            </h3>
            <div v-if="user" class="user-progress-inner" id="accordion" :class="accordionDisplayed ? 'is-visible' : ''">
                <ul class="user-progress-info">
                    <!-- <li v-if="user.rank">{{ user.rank }}
                        <span class="label">{{ $t('labels.overall_rank') }}</span>
                    </li> -->
                    
                    <li>{{ user.completed.length }}<span class="lighten">/{{ storiesNbr }}</span>
                        <span class="label">{{ $t('labels.stories_completed') }}</span>
                    </li>
                    <li>{{ user.success ? user.success : 0 }}<span class="lighten">%</span>
                        <span class="label">{{ $t('labels.success_rate') }}</span>
                    </li>
                </ul>
                <btn
                    v-if="shareAvailable"
                    :class="'transparent transparent--secondary'"
                    @click="$emit('displayShare')"
                    >
                    {{ $t('share.cta') }}
                    <sprite
                        :type="'arrow-right'"
                        :width="19"
                        :height="12"
                    />
                </btn>
            </div>
        </div>
    </div>
</template>

<script>
import Btn from '@/components/components/Btn.vue';
import Sprite from '@/components/components/Sprite.vue';

export default {
  components: {
      Sprite,
      Btn
  },
  mounted() {
      const accordion = document.getElementById('accordion');
      this.height = accordion.offsetHeight;
      accordion.style.height = '0';
      this.accordionDisplayed = false;
  },
  data() {
      return {
          height: null,
          accordionDisplayed: true
      };
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    storiesNbr: {
      type: Number,
      required: true
    },
    shareAvailable: {
      type: Boolean,
      required: true
    }
  },
  methods: {
      toggleAccordion() {
        const accordion = document.getElementById('accordion');
        const chevron = document.querySelector('.chevron-down');
        this.accordionDisplayed = !this.accordionDisplayed;
        if (this.accordionDisplayed) {
            chevron.style.transform = 'rotate(180deg)';
            accordion.style.height = `${this.height}px`;
        } else {
            chevron.style.transform = 'rotate(0)';
            accordion.style.height = '0';
        }
      }
  }
};
</script>

<style lang="scss" scoped>
.user-progress {
    &-content {
        .btn {
            @include margin(10px null null);
            display: block;
            width: 100%;
        }
    }
    &-button {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .svg {
            @include padding(null 10px null);
            fill: $secondary;
            transition: transform .3s $ease-out-quad;
        }
    }
    &-inner {
        opacity: 0;
        visibility: hidden;
        transition: height .2s $ease-out-quad, opacity .2s 0s $ease-out-quad, visibility 0s .2s;
        &.is-visible {
            opacity: 1;
            visibility: visible;
            transition: height .2s $ease-out-quad, opacity .2s $ease-out-quad;
        }
    }
    &-info {
        @include padding(10px null null);
        display: flex;
        flex-flow: row wrap;
        li {
            @include font('tertiary', 'regular');
            color: $secondary;
            font-size: rem(36px);
            line-height: 1.1;
            @include mq($until: 330px) {
                font-size: rem(32px);
            }
            + li {
                @include margin(null null null 25px);
            }
            .lighten {
                opacity: .5;
                font-size: rem(28px);
                @include mq($until: 330px) {
                    font-size: rem(24px);
                }
            }
        }
        .label {
            @include font('primary', 'bold');
            display: block;
            max-width: 64px;
            color: rgba($tertiary, .5);
            font-size: rem(10px);
            line-height: 1.333;
        }
    }
}

</style>
